// extracted by mini-css-extract-plugin
export default {"loanPaymentContainer":"LoanPayment_loanPaymentContainer__U6X7D","loanDetails":"LoanPayment_loanDetails__R9fX2","field":"LoanPayment_field__bPLk3"};